export const termsRoute = () => '/terms-and-conditions';
export const privacyRoute = () => '/privacy-policy';
export const refundRoute = () => '/refund-policy';
export const eulaRoute = () => '/agreement';
export const cookieRoute = () => '/cookie-policy';
export const learningCenterRoute = () => '/learningcenter';

export const helpRoute = () => '/help';
